export const STUDY_MANAGEMENT_FLAGS = {
    review: {
        id: 'review',
        value: false,
        description: 'Enables the review tab under Build section for a study',
        owner: 'Enterprise experience team',
        name: 'Review',
        extra: { section: 'Studies' },
    },
    experimentalPackages: {
        id: 'experimentalPackages',
        value: false,
        description: `When enabled, study build will use non-stable 'dev-latest' template`,
        owner: 'Enterprise experience team',
        name: 'Use latest template',
        extra: { section: 'Studies' },
    },
    genStudy: {
        id: 'getStudy',
        value: false,
        description: 'Enables GenStudy, used to generate studies via AI',
        owner: 'Enterprise experience team',
        name: 'GenStudy',
        disabled: false,
        extra: { section: 'Studies' },
    },
    studySummary: {
        id: 'studySummary',
        value: false,
        description: 'Enables Study Summary in Build section & PDS under Versions',
        owner: 'Study Test Team',
        name: 'Study Summary',
        extra: { section: 'Studies' },
    },
    view_reports: {
        id: 'view_reports',
        value: false,
        description: 'Enables the view reports feature',
        owner: 'Clinical Data',
        name: 'View Reports',
        extra: { section: 'Data', dataTestId: 'view-reports-flag' },
    },
    build_reports: {
        id: 'build_reports',
        value: false,
        description: 'Enables the build reports feature',
        owner: 'Clinical Data',
        name: 'Build Reports',
        extra: { section: 'Data', dataTestId: 'build-reports-flag' },
    },
};
